import * as React from 'react';
import { useLocation } from 'react-router';

import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

export const useOpenBVModal = (
  containerRef: React.MutableRefObject<HTMLDivElement>
) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { bazaarvoiceIntegrationPd } = useFeatureFlags();

  React.useEffect(() => {
    const currentRef = containerRef.current;

    const onOpenModal = () => {
      const mailQuery = searchParams.get('mail');

      if (mailQuery === '1' && bazaarvoiceIntegrationPd) {
        const firstReviewButton = currentRef.querySelector('#first-to-write');
        const moreToWriteButton = currentRef.querySelector('.bv-write-review');

        if (firstReviewButton) {
          (firstReviewButton as HTMLButtonElement).click();
          return;
        }

        if (moreToWriteButton) {
          (moreToWriteButton as HTMLButtonElement).click();
          return;
        }
      }
    };

    if (currentRef) {
      currentRef.addEventListener('DOMNodeInserted', onOpenModal);

      return () => {
        currentRef.removeEventListener('DOMNodeInserted', onOpenModal);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
